import { render } from "./deals-index.vue?vue&type=template&id=6955b640"
import script from "./deals-index.vue?vue&type=script&lang=js"
export * from "./deals-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__